<!-- //
工作台的大屏工作台属性
@auth xuyd
@date 2024-05-03
//-->
<template>
  <el-tabs v-model="selectedTab" type="border-card" style="height: 100%;">
    <el-tab-pane label="视图样式" name="1" style="height: 100%;">
      <el-form @submit.native.prevent class="form" ref="refForm" :model="form" size="mini" :label-width="this.dvContants.labelWidth">
        <el-form-item prop="pageName" label="名称">
          <span class="label">{{form.pageName}}</span>
        </el-form-item>
        <el-form-item prop="width" label="宽度">
          <el-input v-model="form.width" style="width: 100%" maxlength="6">
            <template slot="append">px</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="height" label="高度">
          <el-input v-model="form.height" style="width: 100%" maxlength="6">
            <template slot="append">px</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="backgroundColor" label="背景色">
          <ColorSelector v-model="form.backgroundColor" style="width: 100%"/>
        </el-form-item>
        <el-form-item prop="createTime" label="创建时间">
          <span class="label">{{ $util.parseTime(form.createTime, '{y}-{m}-{d} {h}:{i}') }}</span>
        </el-form-item>
      </el-form>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: 'WidgetWorkbenchForm',
  components: {},
  data() {
    return {
      selectedTab: '1',
      form: {
        id: null,
        presetLine: [],
        pageName: null, // 大屏页面标题
        width: null, // 大屏设计宽度
        height: null, // 大屏设计高度
        backgroundColor: null, // 大屏背景色
        refreshSeconds: null, // 大屏刷新时间间隔
        createTime: null // 创建时间
      }
    }
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    widgetProps: {
      handler: function (val) {
        this.form = val;
      },
      immediate: true
    }
  },
}
</script>

<style lang="less" scoped>

.form {
  .label {
    font-size: 12px;
    color: #a8e3ff;
  }
}
</style>
